"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isMobile = function (number) { return number[0] === '9'; };
var clear = function (phone) { return phone.replace(/\D/g, ''); };
var normalize = function (input, defaultCode, minLength) {
    if (defaultCode === void 0) { defaultCode = ''; }
    if (minLength === void 0) { minLength = 8; }
    var code = defaultCode;
    var value = clear(input);
    if (value.length === 0) {
        throw new Error('Empty value');
    }
    if (value.length < minLength) {
        throw Error('Minimum length is ' + minLength);
    }
    if (value.length > 11) {
        value = value.substr(0, -11);
    }
    if (value.length > 9) {
        code = value.substr(0, 2);
        value = value.substr(2);
    }
    if (value.length === 8 && ['7', '8', '9'].indexOf(value[0])) {
        value = '9' + value;
    }
    return {
        code: code,
        value: value,
        hasCode: code.length >= 2,
        isMobile: isMobile(value),
    };
};
/**
 * @param {string|PhoneNormalized} input
 */
var format = function (input) {
    var phoneData = typeof input === 'string' ? normalize(input) : input;
    var prefixLen = phoneData.isMobile ? 5 : 4;
    var pattern = "(\\d{4," + prefixLen + "})(\\d{4})";
    var regex = new RegExp(pattern);
    var formated = '';
    if (phoneData.hasCode) {
        formated = "(" + phoneData.code + ") ";
    }
    formated += phoneData.value.replace(regex, '$1-$2');
    return formated;
};
var phoneFormater = {
    clear: clear,
    normalize: normalize,
    isMobile: isMobile,
    format: format,
};
exports.default = phoneFormater;
